import type { FC } from 'react'
import { useForm } from 'react-hook-form'
import { Button, Input } from 'components/ui'
import { Certificate } from 'components/icons'
import s from './recover-password.module.css'
import type { RecoverPasswordProps, RecoverPasswordRequest } from '.'

const RecoverPassword: FC<RecoverPasswordProps> = ({ onCancel, onSubmit, forceChangePassword }) => {
  const {
    register,
    handleSubmit,
    formState: { errors, touched, isSubmitting },
  } = useForm({
    mode: 'onChange',
  })

  const handleFormSubmit = (data: RecoverPasswordRequest) => {
    onSubmit({ email: data.email })
  }

  return (
    <div className={s.root}>
      {forceChangePassword ? (
        <div className={s.forceChangePassword}>
          <span>
            Olá!
            <br />
            <br />
            Estamos implementando melhorias na nossa e na sua segurança. Para isso precisamos que você atualize sua
            senha de acesso.
          </span>
        </div>
      ) : (
        <h1 className={s.title}>Recupere sua senha</h1>
      )}

      <form onSubmit={handleSubmit(handleFormSubmit)} className={s.form}>
        <Input
          type="email"
          name="email"
          placeholder="Seu E-mail"
          error={errors?.email?.message}
          defaultValue={forceChangePassword || ''}
          touched={touched?.email}
          maxLength={56}
          disabled={isSubmitting}
          ref={register({
            required: {
              value: true,
              message: 'Por favor, informe seu e-mail',
            },
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'E-mail inválido',
            },
          })}
        />

        <Button variant="primary" type="submit" loading={isSubmitting}>
          {forceChangePassword ? 'Trocar minha senha' : 'Receber código'}
        </Button>
      </form>

      <Button variant="link" onClick={onCancel}>
        Voltar
      </Button>
    </div>
  )
}

export default RecoverPassword
